module.exports = __webpack_public_path__ + "static/media/disabled-photos-dark.ba11bc35.svg";